import React from 'react';
import clsx from 'clsx';
interface ArrowIconProps {
    color?: string;
    direction?: 'right' | 'left' | 'top' | 'bottom';
    size?: number;
    style?: React.CSSProperties;
    className?: string;
    clickHandler?: () => void;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({
    color = 'black',
    direction = 'right',
    size = 20,
    style,
    className,
    clickHandler = () => {},
}) => {
    const getTransform = () => {
        switch (direction) {
            case 'right':
                return 'rotate(0)';
            case 'left':
                return 'rotate(180deg)';
            case 'top':
                return 'rotate(-90deg)';
            case 'bottom':
                return 'rotate(90deg)';
            default:
                return 'rotate(0)';
        }
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            className={clsx(className)}
            style={{
                transform: getTransform(),
                transition: 'transform 0.4s ease-in-out',
                ...style,
            }}
            onClick={clickHandler}
        >
            <path
                d="M8.39196 15.394C8.15041 15.6369 7.75728 15.6367 7.5159 15.3937C7.27665 15.1527 7.27682 14.7638 7.51626 14.5231L12.0096 10.0054L7.51556 5.47954C7.27645 5.23873 7.27645 4.8501 7.51556 4.60929C7.75708 4.36606 8.15047 4.36606 8.39199 4.60929L13.05 9.30033C13.4374 9.69047 13.4372 10.3202 13.0495 10.71L8.39196 15.394Z"
                fill={color}
            />
        </svg>
    );
};

export default ArrowIcon;
